// extracted by mini-css-extract-plugin
export var brand = "_4h-9";
export var compact = "_4h-6";
export var extraSmall = "_4h-7";
export var icon = "_4h-0";
export var large = "_4h-4";
export var light = "_4h-1";
export var medium = "_4h-5";
export var outline = "_4h-b";
export var primaryDark = "_4h-a";
export var primaryLight = "_4h-8";
export var primaryModern = "_4h-c";
export var success = "_4h-2";
export var successSolid = "_4h-3";